module.exports = __webpack_public_path__ + "static/media/infography-img.151e40d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/upsellEc/infography-img.png
// module id = 1222
// module chunks = 0